export { View as OurMission } from './view'
